// src/authConfig.js
import { Configuration, LogLevel } from '@azure/msal-browser';
import { APICall } from "./Helpers/API/APICalls";
import { getPowerBiReport, getReportId } from "./Helpers/API/APIEndPoints";



const getAzureConfigDetails = async () => {
  try {
    const response = await APICall(getReportId, "POST", {});
    const data = response.data; 
    
    const azureConfig = data.find((ele: any) => ele.configKey === "WowAzureAuth");

    if (azureConfig && azureConfig?.configValue) {
      
      const parsedConfig = JSON.parse(azureConfig?.configValue);
      const { clientId, clientSecret, tenantId, redirectUrl } = parsedConfig;
      return {
        clientId,
        clientSecret,
        tenantId,
        redirectUrl,
      };
    } else {
      throw new Error("WowUATAzureAuth key not found or configValue is empty");
    }
  } catch (error) {
    console.error("Error fetching Azure Config details:", error);
    throw error;
  }
};

export async function getMsalConfig(): Promise<Configuration> {
  const azureData = await getAzureConfigDetails();

  const msalConfig: Configuration = {
    auth: {
      clientId:  azureData?.clientId || "",
      authority:  `https://login.microsoftonline.com/${azureData?.tenantId}`, 
      redirectUri: azureData?.redirectUrl || "/",
      postLogoutRedirectUri: "/",
    },
    cache: {
      cacheLocation: "localStorage", // or "sessionStorage"
      storeAuthStateInCookie: false, // Set to true if you need to support IE11
    },
  };

  return msalConfig;
}


// export const msalConfig = {
  
//   auth: {
//     clientId: "cf021803-4d98-4bba-8c8e-7f3d1a51ed8b",
//     authority: "https://login.microsoftonline.com/fdcd3b62-88bb-4c4c-bc7e-fdf7f96d8eab",
//     redirectUri: "/",
//     postLogoutRedirectUri: "/",
//   },
//   cache: {
//     cacheLocation: "localStorage", // or "sessionStorage"
//     storeAuthStateInCookie: false, // Set to true if you need to support IE11
//   },

// };

export const loginRequest = {
  scopes: ["user.read", "openid", "profile", "email"]
};
